import * as React from 'react';
import style from '../core.less';
import * as classNames from 'classnames';

interface WSimpleTupelListProps extends React.ClassAttributes<any> {
    data: Array<any>;
    widthName?: number;
    widthValue?: number;
    fontSize?: number;
    styleTitle?: React.CSSProperties;
    styleName?: React.CSSProperties;
    styleValue?: React.CSSProperties;

}

interface WSimpleTupelListState {
    dummy?: string;
}
export class WSimpleTupelList extends React.Component<WSimpleTupelListProps, WSimpleTupelListState> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    render() {

       const styleName: any = this.props.widthName ? {width: this.props.widthName + 'px', maxWidth: this.props.widthName + 'px'} : {};
       const styleValue: any = this.props.widthValue ? {width: this.props.widthValue + 'px', maxWidth: this.props.widthValue + 'px'} : {};
       if (this.props.fontSize) {
        styleName.fontSize = this.props.fontSize + 'px';
        styleValue.fontSize = this.props.fontSize + 'px';
       }
       return (<div
            className={classNames(style.colContainer, style.tupelList)}
            style={{display: 'flex'}}
           >
           {this.props.data.map((tupel: any, idx: number) => {
                    const styleExtraName  = idx === 0 ? this.props.styleTitle ? this.props.styleTitle : {} :
                                                     this.props.styleName ? this.props.styleName : {};
                    const styleExtraValue  = idx === 0 ? this.props.styleTitle ? this.props.styleTitle : {} :
                                                      this.props.styleValue ? this.props.styleValue : {};
                    return (<div
                        key = {'tupel_idx_' + idx}
                        className = {classNames(style.flexItem, style.rowContainer, style.tupelRow)}>
                        <div
                            className = {classNames(style.flexItem, style.tupelName)}
                            style = {{...styleName, ...styleExtraName}}
                        >
                            {tupel.name}
                        </div>
                        <div
                            className = {classNames(style.flexItem, style.tupelValue)}
                            style = {{...styleValue, ...styleExtraValue}}
                        >
                            {tupel.value}
                        </div>
                    </div>); }
           )}
       </div>);
    }
}
